<div
  class="eva-input"
  [class.eva-input--error]="error"
  [class.eva-input--disabled]="disabled"
  [class.eva-input--readonly]="readonly"
  [class.eva-input--focused]="isFocused"
  [class.eva-input--small]="size === 'small'"
  [class.eva-input--medium]="size === 'medium'"
  [class.eva-input--large]="size === 'large'"
  [class.eva-input--inline]="size === 'inline'"
  [class.eva-input--rounded]="variant === 'rounded'"
  [class.eva-input--rectangular]="variant === 'rectangular'"
  [class.eva-input--locked]="locked"
>
  <!-- Label -->
  <label *ngIf="label" [for]="inputId" class="eva-input__label">
    {{ label }}<span *ngIf="required" class="eva-input__required">*</span>
  </label>

  <!-- Input wrapper (pour gérer les icônes) -->
  <div
    class="eva-input__wrapper"
    [class.eva-input__wrapper--has-left-element]="hasLeftElement"
    [class.eva-input__wrapper--has-dual-left-elements]="hasDualLeftElement"
    [class.eva-input__wrapper--has-right-element]="hasRightElement"
  >
    <!-- Bouton lock/unlock -->
    <button
      *ngIf="lockable"
      type="button"
      class="eva-input__lock-toggle eva-input__lock-toggle--left"
      [class.eva-input__lock-toggle--locked]="locked"
      [disabled]="disabled || readonly"
      (click)="toggleLock()"
      [attr.aria-label]="
        locked ? 'Déverrouiller le champ (Ctrl/Cmd + Maj + L)' : 'Verrouiller le champ (Ctrl/Cmd + Maj + L)'
      "
      [attr.title]="
        locked ? 'Déverrouiller le champ (Ctrl/Cmd + Maj + L)' : 'Verrouiller le champ (Ctrl/Cmd + Maj + L)'
      "
    >
      <ng-icon [name]="locked ? 'heroLockClosed' : 'heroLockOpen'"></ng-icon>
    </button>

    <!-- Icône gauche - PrimeNG -->
    <i
      *ngIf="icon && !isHeroIcon"
      [class]="icon"
      class="eva-input__icon eva-input__icon--left"
      [class.eva-input__icon--left-secondary]="hasDualLeftElement"
    ></i>

    <!-- Icône gauche - HeroIcons -->
    <ng-icon
      *ngIf="icon && isHeroIcon"
      [name]="icon"
      class="eva-input__icon eva-input__icon--left"
      [class.eva-input__icon--left-secondary]="hasDualLeftElement"
    ></ng-icon>

    <!-- Input natif -->
    <input
      #inputElement
      [id]="inputId"
      [type]="effectiveType"
      [attr.step]="step"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly || locked"
      [attr.maxlength]="maxlength"
      [autocomplete]="autocomplete"
      [value]="_value"
      class="eva-input__field"
      (input)="onInput($event)"
      (change)="onChangeEvent($event)"
      (keydown)="handleKeydown($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
    />

    <!-- Bouton clear -->
    <button *ngIf="showClear && !isPasswordType" type="button" class="eva-input__clear" tabindex="-1" (click)="clear()">
      <ng-icon name="heroXMark"></ng-icon>
    </button>

    <!-- Password toggle -->
    <button
      *ngIf="isPasswordType && !disabled && !readonly"
      type="button"
      class="eva-input__password-toggle"
      tabindex="-1"
      (click)="togglePasswordVisibility()"
      [attr.aria-label]="showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
    >
      <ng-icon [name]="showPassword ? 'heroEyeSlash' : 'heroEye'"></ng-icon>
    </button>

    <!-- Icône droite - PrimeNG (si pas de clear button ni password toggle) -->
    <i
      *ngIf="iconRight && !showClear && !isPasswordType && !isHeroIconRight"
      [class]="iconRight"
      class="eva-input__icon eva-input__icon--right"
    ></i>

    <!-- Icône droite - HeroIcons (si pas de clear button ni password toggle) -->
    <ng-icon
      *ngIf="iconRight && !showClear && !isPasswordType && isHeroIconRight"
      [name]="iconRight"
      class="eva-input__icon eva-input__icon--right"
    ></ng-icon>
  </div>

  <!-- Helper text (affiché si pas d'erreur) -->
  <small *ngIf="helper && !error" class="eva-input__helper">
    {{ helper }}
  </small>

  <!-- Error message -->
  <small *ngIf="error" class="eva-input__error-text">
    {{ error }}
  </small>
</div>
